"use client"
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import React, { useEffect, useRef, useState } from "react"
import styles from "./index.module.scss"
import dropdownStyles from "../../ui/dropdown/index.module.scss"
import DropdownLog from "../../../components/ui/dropdown"
import WhiteButton from "../../../components/ui/white-button"
import { RoutesIcon } from "./../../icons/routes"
import { FilledTrashIcon } from "../../../components/icons/filled-trash"
import { EmptyTrashIcon } from "../../../components/icons/empty-trash"
import { ManageIcon } from "../../../components/icons/manage"
import LogoutLog from "../../../components/ui/logout"
import { ArrowleftIcon } from "../../../components/icons/arrow-left"
import { logout } from "../../../utils/functions"
import ModalDialog from "../../../components/ui/delete-modal"
import { useDispatch } from "react-redux"

export default function SideBar({
  hide,
  setOpenModal,
  setHide,
  binList,
  user,
  setOpenProfileModal,
  displayRoutes,
  setDisplayRoutes,
  selectedZone,
  setSelectedZone,
  showFilledBins,
  setShowFilledBins,
  showNotFilledBins,
  setShowNotFilledBins,
  isTimelineChartVisible,
  setTimelineChartVisible
}) {
  const dispatch = useDispatch()
  const isIntersectingRef = useRef(null)
  const [isIntersecting, setIntersecting] = useState(false)
  const [fillLevel, setFillLevel] = useState("")
  const [isModal, setIsModal] = useState(false)
  const [activeButton, setActiveButton] = useState('All');


  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(entry.isIntersecting)
    })
    observer.observe(isIntersectingRef.current)

    return () => observer.disconnect()
  }, [])

  return (
    <aside className={`${styles.container} ${hide ? styles.hide : ""}`}>
      <ModalDialog
        open={isModal}
        confirm={() => {
          logout()
          setIsModal(false)
        }}
        cancel={() => setIsModal(false)}
        label={"Logout"}
        description={`Are you sure you want to logout from this platform?`}
        warn={`You can't undo this action`}
      />

      <img
        src="/media/logo/logo-white.svg"
        alt={""}
        className={`${styles.logo} ${hide ? styles.hide : ""}`}
      />
      <div className={styles.zones}>
        <DropdownLog hide={hide} selectedZone={selectedZone} setSelectedZone={setSelectedZone} />
        <WhiteButton
          hide={hide}
          title="Routes"
          transparent={true}
          onClick={() => {
            setDisplayRoutes(!displayRoutes);
            setTimelineChartVisible(!isTimelineChartVisible)
          }}
          icon={<RoutesIcon className={dropdownStyles.icon} />}
          active={displayRoutes}
        />
      </div>
      <div className={styles.zones}>
        <div className={styles.text}>Bins</div>
        <div className={styles.zones}>
          {hide ? (
            <ButtonGroup orientation="vertical" color="primary" aria-label="outlined primary button group">
              <Button className={`${styles.switchbutton} ${styles.hide} ${activeButton === 'All' ? styles.activeswitch : styles.normalswitch}`} onClick={() => { setShowFilledBins(true); setShowNotFilledBins(true); setActiveButton('All'); }}>All</Button>
              <Button className={`${styles.switchbutton} ${styles.hide} ${activeButton === 'Filled' ? styles.activeswitch : styles.normalswitch}`} onClick={() => { setShowFilledBins(true); setShowNotFilledBins(false); setActiveButton('Filled'); }}>Filled</Button>
              <Button className={`${styles.switchbutton} ${styles.hide} ${activeButton === 'Not Filled' ? styles.activeswitch : styles.normalswitch}`} onClick={() => { setShowFilledBins(false); setShowNotFilledBins(true); setActiveButton('Not Filled'); }}>Not Filled</Button>
            </ButtonGroup>
          ) : (
              <ButtonGroup color="primary" aria-label="outlined primary button group">
              <Button className={`${styles.switchbutton} ${activeButton === 'All' ? styles.activeswitch : styles.normalswitch}`} onClick={() => { setShowFilledBins(true); setShowNotFilledBins(true); setActiveButton('All'); }}>All</Button>
              <Button className={`${styles.switchbutton} ${activeButton === 'Filled' ? styles.activeswitch : styles.normalswitch}`} onClick={() => { setShowFilledBins(true); setShowNotFilledBins(false); setActiveButton('Filled'); }}>Filled</Button>
              <Button className={`${styles.switchbutton} ${activeButton === 'Not Filled' ? styles.activeswitch : styles.normalswitch}`} onClick={() => { setShowFilledBins(false); setShowNotFilledBins(true); setActiveButton('Not Filled'); }}>Not Filled</Button>
            </ButtonGroup>
          )}
        </div>
      </div>
      <div className={styles.zones}>
        <div className={styles.text}>Stops</div>
        <div className={styles.zones}>
          <WhiteButton
            hide={hide}
            title="Manage Stops"
            transparent={false}
            onClick={() => setOpenModal(true)}
            icon={<ManageIcon className={dropdownStyles.icon} />}
          />
        </div>
      </div>
      <section className="mt-auto">
        <LogoutLog
          hide={hide}
          user={user}
          setOpenProfileModal={setOpenProfileModal}
          setIsModal={setIsModal}
        />
        <button
          ref={isIntersectingRef}
          onClick={() => setHide(!hide)}
          className={styles.button}
        >
          <ArrowleftIcon
            style={{ transform: hide ? "rotate(180deg)" : "" }}
            className={dropdownStyles.icon}
          />
          {hide ? "" : "Hide Sidebar"}
        </button>
      </section>
      <div
        style={{ opacity: isIntersecting ? "0" : "1" }}
        className={styles.sticky}
      ></div>
    </aside>
  )
}
